import React, { ReactComponentElement } from 'react';
import { chain } from 'lodash';
import {
    ButtonPrimary,
    IconTrash,
    DataTableBodyV2,
    DataTableCellV2,
    DataTableHeadCellV2,
    DataTableHeadV2,
    DataTableRowV2,
    DataTableV2
} from '@americanexpress/dls-react';
import { useVisibleAccounts } from 'src/hooks/queries/accounts';
import styles from './adminSetSyncStatusForm.module.scss';
import { AccountModel } from 'src/types/account.model';
import { InstitutionModel } from 'src/types/institution.model';
import InstitutionService from 'src/services/institution.service';
import useAsyncCallback from 'src/hooks/useAsyncCallback';
import { DLSSize } from 'src/types/dls-size.enum';
import LiteralsService from 'src/services/literals/LiteralsService';

export function AdminDeleteInstitutionForm(): ReactComponentElement<any> {
    const { isLoading: isLoadingAccounts, data: accounts } = useVisibleAccounts();

    const deleteInstitution = useAsyncCallback(
        async (institution: InstitutionModel) => {
            await InstitutionService.deleteInstitution(institution);
            location.reload();
        },
        [accounts]
    );

    if (isLoadingAccounts) {
        return <p>{LiteralsService.getLiteral('Admin.Account.DeleteInstitution.loading')}</p>;
    } else {
        const institutions = chain<AccountModel>(accounts)
            .groupBy((account) => account.institutionId)
            .toPairs()
            .map<[InstitutionModel, [AccountModel, ...AccountModel[]]]>(([_, accounts]) => [
                accounts[0].institution,
                accounts
            ])
            .value();
        return (
            <div className={styles.container}>
                <DataTableV2 id="tablev2-expandable-instance">
                    <DataTableHeadV2>
                        <DataTableRowV2 id="tablev2-expandable-header-row">
                            <DataTableHeadCellV2>
                                {LiteralsService.getLiteral('Admin.Account.DeleteInstitution.institutionHeader')}
                            </DataTableHeadCellV2>
                            <DataTableHeadCellV2>
                                {LiteralsService.getLiteral('Admin.Account.DeleteInstitution.accountHeader')}
                            </DataTableHeadCellV2>
                            <DataTableHeadCellV2>
                                {LiteralsService.getLiteral('Admin.Account.DeleteInstitution.deleteHeader')}
                            </DataTableHeadCellV2>
                        </DataTableRowV2>
                    </DataTableHeadV2>
                    <DataTableBodyV2>
                        {accounts.length > 0 &&
                            institutions.map(([institution, accounts], i) => (
                                <DataTableRowV2
                                    key={i}
                                    expandButtonLabel="expand-sainsBuryE"
                                    expanded={false}
                                    id="sainsBuryE"
                                    rowIndex={i}
                                >
                                    <DataTableCellV2 colIndex={1}>{institution.name}</DataTableCellV2>
                                    <DataTableCellV2 colIndex={2}>
                                        {accounts.map((account) => (
                                            <span key={account.name}>
                                                {account.name}
                                                <br />
                                            </span>
                                        ))}
                                    </DataTableCellV2>
                                    <DataTableCellV2 colIndex={3}>
                                        <ButtonPrimary
                                            aria-describedby="icon-button-label"
                                            icon={<IconTrash />}
                                            size={DLSSize.MEDIUM}
                                            onClick={async () => await deleteInstitution(institution)}
                                        />
                                    </DataTableCellV2>
                                </DataTableRowV2>
                            ))}
                    </DataTableBodyV2>
                </DataTableV2>
            </div>
        );
    }
}
